export default "__VITE_ASSET__B9C3Riey__"